const langDocumentFile = {
	fund_name: {
		tag: 'document.file.fund_name',
		fr: 'Fonds',
		en: 'Fund',
	},
	fund_type: {
		tag: 'document.file.fund_type',
		fr: 'Type de fonds',
		en: 'Fund type',
	},
	document_type: {
		tag: 'document.file.document_type',
		fr: 'Type de document',
		en: 'Document type',
	},
	released_date: {
		tag: 'document.file.released_date',
		fr: 'Date de diffusion',
		en: 'Released date',
	},
	subtitle_looking_other_x_documents: {
		tag: 'document.file.subtitle_looking_other_x_documents',
		fr: 'Autres documents de type {{documentTypeName}}',
		en: 'Looking for other {{documentTypeName}} documents ?',
	},
	btn_download: {
		tag: 'document.file.btn_download',
		fr: 'Télécharger',
		en: 'Download',
	},
	btn_downloading: {
		tag: 'document.file.btn_downloading',
		fr: 'Téléchargement en cours...',
		en: 'Downloading...',
	},
	downloading_error_404: {
		tag: 'document.file.downloading_error_404',
		fr: "Impossible d'accéder au fichier. Nous vous prions de nous excuser pour le désagrément occasionné. L'équipe de support a été contactée pour résoudre le problème rapidement.",
		en: 'Unable to access the file. We apologise for the inconvenience. The support team has been contacted to resolve the problem quickly.',
	},
	downloading_error_no_current_document: {
		tag: 'document.file.downloading_error_no_current_document',
		fr: 'Erreur interne : Impossible de télécharger ce document pour le moment',
		en: 'Error interne : Unable to download this document right now',
	},
	link_go_back_documents: {
		tag: 'document.file.link_go_back_documents',
		fr: 'Retour aux documents',
		en: 'Go back to all my documents',
	},
};

export default langDocumentFile;
